import { type OptionsFetchQueryResult, OptionsType } from '@openx/types/options.ts';
import type { UseQueryOptions } from '@openx/types/reactQuery.ts';
import { useTranslation } from 'react-i18next';

import { useOptionsFetch } from './generics/useOptionsFetch.tsx';

export function useOldDeviceTypesOptionsFetch(queryOptions?: UseQueryOptions<OptionsFetchQueryResult>) {
  const { t } = useTranslation();
  const {
    isLoading: isDeviceTypesLoading,
    data: deviceTypes,
    refetch: refetchDeviceTypes,
  } = useOptionsFetch({
    errorMessage: t('Failed to fetch Device types'),
    optionType: OptionsType.OLD_DEVICE_TYPE,
    queryOptions,
  });

  return {
    deviceTypes,
    isDeviceTypesLoading,
    refetchDeviceTypes,
  };
}
